import { ILoteSolicitadoRepository } from '../repositories/ILoteSolicitadoRepository'

export interface ISendSms {
  execute(loteId: number, sendSms: boolean): Promise<void>
}

export default class ISendSmsImpl implements ISendSms {
  constructor(
    private readonly loteSolicitadoRepository: ILoteSolicitadoRepository,
  ) {}

  public async execute(loteId: number, sendSms: boolean): Promise<void> {
    await this.loteSolicitadoRepository.sendSms(loteId, sendSms)
  }
}
